export function isAiAllowHost() {
  const { host } = window.location
  const aiAllowHosts = ['localhost:8080', 'stage.flomoapp.com', '192.168.1.3:8080']
  return aiAllowHosts.includes(host)
}
